(() => {
  const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fineHover.matches || reducedMotion.matches) return;

  const wrapperSelector = '.product-card-wrapper';
  const videoSelector = '.rhinestone-hover-video-shell video';

  const start = (wrapper) => {
    const video = wrapper.querySelector(videoSelector);
    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    if (video.readyState === 0) {
      try {
        video.load();
      } catch (_) {
        // Loading is best-effort; play() below also triggers it.
      }
    }

    const playAttempt = video.play();
    if (playAttempt && typeof playAttempt.then === 'function') {
      playAttempt
        .then(() => wrapper.classList.add('rhinestone-hover-video-active'))
        .catch(() => {
          // Even if playback is refused, show the layer: the poster frame
          // paints instead of a blank box.
          wrapper.classList.add('rhinestone-hover-video-active');
        });
    } else {
      wrapper.classList.add('rhinestone-hover-video-active');
    }
  };

  const stop = (wrapper) => {
    const video = wrapper.querySelector(videoSelector);
    if (!video) return;

    wrapper.classList.remove('rhinestone-hover-video-active');
    video.pause();
    try {
      video.currentTime = 0;
    } catch (_) {
      // Some browsers restrict seeking before metadata is available.
    }
  };

  // Listen on the whole card wrapper: Dawn stretches the title link over the
  // card, so the element under the pointer is often the link, not the media.
  document.addEventListener('mouseover', (event) => {
    const wrapper = event.target.closest(wrapperSelector);
    if (wrapper) start(wrapper);
  });

  document.addEventListener('mouseout', (event) => {
    const wrapper = event.target.closest(wrapperSelector);
    if (!wrapper) return;
    if (!wrapper.contains(event.relatedTarget)) stop(wrapper);
  });
})();
